import useEditorContext from "../useEditorContext";
import { BRUSH_COLORS, BrushColor } from "../../tools/BrushTool";
import ToolbarColors from "./ToolbarColors";

const ToolbarActionBrush = () => {
  const { setToolOptions, toolOptions } = useEditorContext();

  const onClick = (color: BrushColor) => {
    setToolOptions({ color });
  };

  const currentColor =
    toolOptions && "color" in toolOptions && toolOptions.color
      ? toolOptions.color
      : null;

  return (
    <div className="h-12">
      <ToolbarColors
        colors={BRUSH_COLORS}
        currentColor={currentColor}
        onClick={onClick}
      />
    </div>
  );
};

export default ToolbarActionBrush;
